export default __webpack_public_path__ + "static/media/1811.ea89e79a.png";